import { connect } from 'react-redux';
import { selectActiveVenueId } from 'selectors/general';
import { goToTab } from '../../ManageServices.saga';
import { selectPractitioners } from '../../Practitioners/Practitioners.selectors';
import { selectResources } from '../../Resources/Resources.selectors';
import { createService } from '../Services.saga';
import { messages } from '../Services.messages';
import ServiceForm from './ServiceForm';

const mapStateToProps = state => {
  const practitioners = selectPractitioners(state);
  const resources = selectResources(state);

  return {
    isEditing: false,
    title: messages.form.addService,
    practitioners: practitioners?.map(({ id, firstName, lastName, recurrence }) => ({
      id,
      name: firstName ? `${firstName} ${lastName}` : lastName,
      recurrence,
    })),
    resources: resources?.map(({ id, name, recurrence }) => ({ id, name, recurrence })),
    venueId: selectActiveVenueId(state),
  };
};

const mapDispatchToProps = {
  handleSubmit: createService,
  handleCancel: goToTab,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceForm);
